/**
 * Last-resort renderer for failures that happen before React can mount.
 *
 * Built via `textContent`, never `innerHTML`: `error` can carry an
 * attacker-supplied `error_description` from the AAD redirect fragment, which
 * `innerHTML` would parse as markup and execute in our own origin.
 */
export function renderBootstrapError(container: HTMLElement, error: unknown): void {
  container.textContent = ''

  const box = document.createElement('div')
  box.style.cssText = 'font-family:sans-serif;padding:2rem;color:#b91c1c'

  const heading = document.createElement('strong')
  heading.textContent = 'Failed to initialise authentication.'

  const detail = document.createElement('pre')
  detail.style.cssText = 'margin-top:1rem;font-size:0.8rem;white-space:pre-wrap'
  detail.textContent = String(error)

  box.append(heading, detail)
  container.appendChild(box)
}
